import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../config';
import { LogService } from '../services/logging.service';
import { ApigeeDAO } from './apigee.dao';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { EmailUsageDataValidator } from './validators/data.validators';

const CLASS_NAME = 'EmailUsageDao';

@Injectable()
export class EmailUsageDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.emailUsageDAO, new DefaultRetryHandler(), new EmailUsageDataValidator(), log, cookieService);
  }

  public post(request): Observable<any> {
    const url = this.daoConfig.url;
    return this.doPost(url, request);
  };
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/email-usage.dao.ts